import { cn } from "@/lib/utils";

/**
 * Fixed strip above the page bottom that positions its child on the app's
 * content rail (same max-w/padding as the page rails), so floating pills
 * follow the app's content margin instead of the viewport edge. The
 * full-width strip must not eat clicks — the child slot restores them.
 */
export const FloatingRailSlot = ({
  side = "left",
  className,
  children,
}: {
  side?: "left" | "right";
  /** Extra classes for the strip (e.g. the global ad bottom offset). */
  className?: string;
  children: React.ReactNode;
}) => (
  <div
    className={cn(
      "pointer-events-none fixed inset-x-0 bottom-4 z-40 pb-4",
      className,
    )}
  >
    <div className="mx-auto w-full max-w-content px-4 large:px-16 touch-device:px-4">
      <div
        className={cn(
          "pointer-events-auto relative w-fit",
          side === "right" && "ml-auto",
        )}
      >
        {children}
      </div>
    </div>
  </div>
);
